import React from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Users, Copy } from 'lucide-react';
import { toast } from 'sonner';

const Referrals = () => {
  const referralCode = 'AQ' + Math.random().toString(36).substr(2, 8).toUpperCase();

  const copyCode = () => {
    navigator.clipboard.writeText(referralCode);
    toast.success('Referral code copied!');
  };

  return (
    <div className="space-y-8 animate-fadeIn">
      <div>
        <h1 className="text-4xl font-bold text-black mb-2">Refer a Friend</h1>
        <p className="text-gray-600">Earn rewards by inviting friends to Aqua blockchain</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="p-6">
          <h2 className="text-xl font-bold text-black mb-4 flex items-center">
            <Users className="w-5 h-5 mr-2 text-[#FF5A5A]" />
            Your Referral Code
          </h2>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
            <p className="text-2xl font-bold text-black text-center mb-3">{referralCode}</p>
            <Button onClick={copyCode} className="w-full text-white hover:opacity-90" style={{ background: '#062136' }}>
              <Copy className="w-4 h-4 mr-2" />
              Copy Code
            </Button>
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="font-semibold text-black mb-3">How it Works</h3>
          <ul className="space-y-2 text-sm text-gray-600">
            <li className="flex items-start">
              <span className="text-[#FF5A5A] mr-2">1.</span>
              <span>Share your referral code with friends</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#FF5A5A] mr-2">2.</span>
              <span>They sign up and complete KYC verification</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#FF5A5A] mr-2">3.</span>
              <span>You both earn rewards when they make their first trade</span>
            </li>
          </ul>
        </Card>
      </div>

      <Card className="p-6">
        <h3 className="font-semibold text-black mb-3">Referral Stats</h3>
        <div className="grid grid-cols-3 gap-4">
          <div className="text-center">
            <p className="text-3xl font-bold text-black">0</p>
            <p className="text-sm text-gray-600">Referrals</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-black">$0</p>
            <p className="text-sm text-gray-600">Earned</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-black">0</p>
            <p className="text-sm text-gray-600">Pending</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Referrals;